/* @flow */
import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import withData from "../withData";
import Gettext from "../common/Gettext";

import type { MapStateToProps } from "react-redux";
import type { State as ReduxState } from "../../redux/reducer";

const Container = styled.div`
  direction: ${props => props.theme.direction};
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  color: ${({ theme }) => theme.foreground};
`;

function Profit(props) {
  const activeStock = props.stocks[props.tabs.tabs[props.tabs.activeTab]];

  const activeAccount = props.accounts.find(
    account => account.id === props.profile.active_account_id
  );

  let percent = null;

  if (activeAccount) {
    percent =
      activeAccount.type === "real"
        ? activeStock.realProfit
        : activeStock.demoProfit;

    if (props.tradeMode === "tournament") {
      percent = activeStock.realProfit - activeStock.profit_vip;
    }
  }

  return (
    <Container>
      <Gettext>Profit: {percent}</Gettext>%
    </Container>
  );
}

function mapStateToProps(state: ReduxState) {
  return {
    tradeMode: state.settings.mode,
    tabs: state.tabs,
    stocks: state.stocks
  };
}

export default withData(["accounts", "profile"])(
  connect((mapStateToProps: MapStateToProps<*, *, *>))(Profit)
);



// WEBPACK FOOTER //
// ./src/components/TradeMobile/Profit.js